// Home.tsx
import React from "react";
import { Box, ListItem, ListItemText, Typography } from "@mui/material";
import zodiacIcon from "./../../assets/zodiac.png";
import numerologyIcon from "./../../assets/numerology.png";
import tarotIcon from "./../../assets/tarot.png";
import { Link } from "react-router-dom";
import { menuItems } from "../../components/Sidebar";
const Home: React.FC = () => {
  return (
    <Box>
      <Box
        sx={{
          padding: "10px",
        }}
      >
        <Typography
          color="primary"
          sx={{
            fontWeight: "bold",
            fontSize: "24px",
          }}
        >
          Astrology CMS
        </Typography>
      </Box>
      <Box
        sx={{
          padding: "10px",
          display: "flex",
          alignItems: "flex-start",
          "& .box_item": {
            backgroundColor: "#F7FAFC",
            padding: "10px",
            borderRadius: "10px",
            margin: "10px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            cursor: "pointer",
            "&:hover": {
              "& .box_item_text": {
                fontWeight: "bold",
              },
            },
          },
          "& img": {
            width: "240px",
            borderRadius: "10px",
          },
          "& .box_item_text": {
            fontSize: "16px",
            marginTop: "10px",
            fontWeight: "bold",
          },
        }}
      >
        <Box className="box_item">
          <img src={zodiacIcon} />
          <Typography className="box_item_text">Zodiac</Typography>
          {menuItems[0].subItems?.map((subItem: any) => {
            return (
              <ListItem key={subItem.id} component={Link} to={subItem.link}>
                <ListItemText
                  primary={subItem.name}
                  color="primary"
                  sx={{
                    "& span": {
                      fontWeight: "300",
                      fontSize: "14px",
                    },
                  }}
                />
              </ListItem>
            );
          })}
        </Box>
        <Box className="box_item">
          <img src={numerologyIcon} />
          <Typography className="box_item_text">Numerology</Typography>
          {menuItems[1].subItems?.map((subItem: any) => {
            return (
              <ListItem key={subItem.id} component={Link} to={subItem.link}>
                <ListItemText
                  primary={subItem.name}
                  color="primary"
                  sx={{
                    "& span": {
                      fontWeight: "300",
                      fontSize: "14px",
                    },
                  }}
                />
              </ListItem>
            );
          })}
        </Box>
        <Box className="box_item">
          <img src={tarotIcon} />
          <Typography className="box_item_text">Tarot</Typography>
          {menuItems[2].subItems?.map((subItem: any) => {
            return (
              <ListItem key={subItem.id} component={Link} to={subItem.link}>
                <ListItemText
                  primary={subItem.name}
                  color="primary"
                  sx={{
                    "& span": {
                      fontWeight: "300",
                      fontSize: "14px",
                    },
                  }}
                />
              </ListItem>
            );
          })}{" "}
        </Box>
      </Box>
    </Box>
  );
};

export default Home;
